import React, {useState, useEffect} from "react";
import {ListGroup, Modal, Table} from "react-bootstrap";
import GestorArchivos from "../GestorArchivos";
import FormularioPuntoVenta from "../marketing/FormularioPuntoVenta";
import FormularioPromociones from "../marketing/FormularioPromociones";
import {obtenerPuntosVenta, eliminarPuntoVenta, obtenerMatrizPromociones, eliminarMatrizPromocion} from "../AccionesBackend";
import Button from "react-bootstrap/Button";
import AdminSubNews from "../newsPaper/AdminSubNews";  // Asegúrate de tener este componente
import AdminNews from "../newsPaper/AdminNews";
import AdminUsuarios from "../GestionUsuarios/FormularioUsuarios"
import BannerBienvenidaResponsivo from "./BannerBienvenidaResponsivo";
import Swal from "sweetalert2";
import AdminPaquetes from "../paquetes/AdminPaquetes";




const imagenes = ".jpg,.jpeg,.png";
const audios = ".mp3,.wav,.ogg,.mpeg,.m4a";
const videos = ".mp4,.mov,.avi";
const pdfs = ".pdf";
const words = ".doc,.docx";
const excels = ".xls,.xlsx";
const powerpoints = ".ppt,.pptx";
const zipRar = ".zip,.rar";

const CATEGORIAS = {
    Usuarios:[
        {id:31,nombre: "Gestion de usuarios", acceptedFileTypes: ""}
    ],
    Principal: [
        {id: 1, nombre: "Carrusel", acceptedFileTypes: imagenes},
    ],
    Marketing: [
        {id: 21, nombre: "Carrusel Marketing", acceptedFileTypes: imagenes},
        {id: 16, nombre: "Perifoneos", acceptedFileTypes: audios},
        {id: 17, nombre: "Barker", acceptedFileTypes: videos},
        {id: 18, nombre: "Flyers Digitales", acceptedFileTypes: imagenes},
        {id: 19, nombre: "Flyers Marketplace", acceptedFileTypes: imagenes},
        {id: 29, nombre: "Material de apoyo", acceptedFileTypes: imagenes, pdfs, videos, audios, powerpoints, words, excels, zipRar},
        {id: 20, nombre: "Puntos de Venta", acceptedFileTypes: imagenes},
        {id: 23, nombre: "Promociones IZZI", acceptedFileTypes: imagenes},
        {id: 24, nombre: "Promociones SKY", acceptedFileTypes: imagenes},
        {id: 25, nombre: "Promociones IZZI MOVIL", acceptedFileTypes: imagenes},
        {id: 26, nombre: "Promociones WIZZ", acceptedFileTypes: imagenes},
    ],
    Lineamientos: [
        {id: 3, nombre: "Se Nice", acceptedFileTypes: `${pdfs},${words}`},
        {id: 4, nombre: "Código de Vestimenta", acceptedFileTypes: `${imagenes},${pdfs}`},
        {id: 5, nombre: "Cultura", acceptedFileTypes: `${imagenes},${pdfs}`},
        {id: 6, nombre: "NOM-35", acceptedFileTypes: `${imagenes},${pdfs}`},
        {id: 7, nombre: "Normas de Conducta", acceptedFileTypes: `${imagenes},${pdfs}`},
        {id: 9, nombre: "Capacitaciones", acceptedFileTypes: `${pdfs},${imagenes},${words},${excels},${powerpoints}`},
        {id: 8, nombre: "Procesos y politicas", acceptedFileTypes: `${powerpoints},${pdfs}`},
        {id: 10, nombre: "Protocolos de Servicio", acceptedFileTypes: `${imagenes},${pdfs}`},
    ],
    Reportes: [
        {id: 12, nombre: "Comisiones Vendedores", acceptedFileTypes: `${excels},${pdfs}`},
        {id: 13, nombre: "Comisiones Supervisores", acceptedFileTypes: `${excels},${pdfs}`},
        {id: 14, nombre: "Cintas Vendedores", acceptedFileTypes: `${excels},${pdfs}`},
        {id: 15, nombre: "Cintas Supervisores", acceptedFileTypes: `${excels},${pdfs}`},
    ],
    Noticias: [
        { id: 27, nombre: "Noticias", acceptedFileTypes: imagenes },
        { id: 28, nombre: "Subnoticia", acceptedFileTypes: imagenes } 
      ],
    Servicios: [
    { id: 30, nombre: "Paquetes", acceptedFileTypes: "" },
      ],
};

const GestorAdmin = () => {
    const [seccionSeleccionada, setSeccionSeleccionada] = useState(null);
    const [puntosVenta, setPuntosVenta] = useState([]);
    const [promociones, setPromociones] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalShowPromociones, setModalShowPromociones] = useState(false);
    const [puntoVentaSeleccionado, setPuntoVentaSeleccionado] = useState(null);
    const [promocionSeleccionada, setPromocionSeleccionada] = useState(null);

    // Carga los puntos de venta si la sección seleccionada es la 20
    useEffect(() => {
        if (seccionSeleccionada?.id === 20) {
            refrescarPuntosVenta();
        } else if ([23, 24, 25, 26].includes(seccionSeleccionada?.id)) {
            refrescarMatrizPromociones();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seccionSeleccionada]);

    const refrescarMatrizPromociones = async () => {
        if (!seccionSeleccionada || !seccionSeleccionada.id) {
            console.error("No hay una sección seleccionada válida");
            return;
        }
        try {
            const res = await obtenerMatrizPromociones(seccionSeleccionada.id);
            if (res.success) {
                setPromociones(res.matrizPromociones);
            } else {
                console.error("Error al obtener la matriz de promociones:", res.mensaje);
            }
        } catch (error) {
            console.error("Error al refrescar la matriz de promociones:", error);
        }
    };


    const refrescarPuntosVenta = () => {
        obtenerPuntosVenta().then((res) => {
            if (res.success) {
                setPuntosVenta(res.puntosVenta);
            }
        });
    };


    // Para eliminar un punto de venta
    const handleEliminarPuntoVenta = async (id) => {
        const confirmar = window.confirm("¿Estás seguro de que deseas eliminar este punto de venta?");
        if (!confirmar) return;

        const response = await eliminarPuntoVenta(id);
        if (response.success) {
            // Recargamos la lista
            refrescarPuntosVenta();
        } else {
            Swal.fire({icon: "error", title: "Error", text: "Error al eliminar el punto de venta"});
          return;
           // alert("Error al eliminar el punto de venta");
        }
    };

    const handleEliminarPromocion = async (id) => {
        const confirmar = window.confirm("¿Estás seguro de que deseas eliminar esta promoción?");
        if (!confirmar) return;

        const response = await eliminarMatrizPromocion(id);
        if (response.success) {
            refrescarMatrizPromociones();
        } else {
            Swal.fire({icon: "error", title: "Error", text: response.mensaje || "Error al eliminar la promoción"});
        }
    };

    const rolId = localStorage.getItem("rol_id");

    // Filtrar categorías según rol
    const categoriasFiltradas = Object.entries(CATEGORIAS).filter(([categoria]) => {
        if (parseInt(rolId) === 13 && categoria === "Usuarios") return false;
        return true;
    });

    return (
        <div className="admin-container">
            <div className="admin-sidebar">
                <h2>Secciones</h2>
                {categoriasFiltradas.map(([categoria, secciones]) => (
                    <div key={categoria}>
                        <h3 className="categoria-titulo my-2">{categoria}</h3>
                        <ListGroup>
                            {secciones.map((seccion) => (
                                <ListGroup.Item
                                    key={seccion.id}
                                    action
                                    onClick={() => setSeccionSeleccionada(seccion)}
                                    className={seccionSeleccionada?.id === seccion.id ? "active" : ""}
                                >
                                    {seccion.nombre}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </div>
                ))}
            </div>

            <div className="admin-content">
                {seccionSeleccionada ? (
                    <>
                        <h1>{seccionSeleccionada.nombre}</h1>
                        {seccionSeleccionada.id === 31 ? (
                            <AdminUsuarios />
                        ) : seccionSeleccionada.id === 28 ? (
                             <AdminSubNews />
                             ) : seccionSeleccionada.id === 20 ? (
                            <>
                                {/* Botón para Agregar un nuevo punto de venta */}
                                <div className="d-flex justify-content-start mb-3">
                                    <Button
                                        variant="success"
                                        onClick={() => {
                                            setPuntoVentaSeleccionado(null); // Para que el formulario empiece vacío
                                            setModalShow(true);
                                        }}
                                    >
                                        Agregar nuevo punto de venta
                                    </Button>
                                </div>

                                <Table striped bordered hover className={"custom-table-puntos-venta"}>
                                    <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Estado</th>
                                        <th>Localidad</th>
                                        <th>Dirección</th>
                                        <th>Acciones</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {puntosVenta.map((punto) => (
                                        <tr key={punto.id}>
                                            <td>{punto.title}</td>
                                            <td>{punto.estado}</td>
                                            <td>{punto.localidad}</td>
                                            <td>{punto.direccion}</td>
                                            <td style={{display: "flex", gap: "0.5rem"}}>
                                                <Button
                                                    variant="primary"
                                                    style={{backgroundColor: "#d3702e", border: "none"}}
                                                    onClick={() => {
                                                        setPuntoVentaSeleccionado(punto);
                                                        setModalShow(true);
                                                    }}
                                                >
                                                    Editar
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    style={{backgroundColor: "#d3702e", border: "none"}}
                                                    onClick={() => handleEliminarPuntoVenta(punto.id)}
                                                >
                                                    Eliminar
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </>
                        ) :
                         seccionSeleccionada.id === 27 ? (
                            <AdminNews />
                        ) : seccionSeleccionada.id === 30 ? (
                            <AdminPaquetes />
                          ) : [23, 24, 25, 26].includes(seccionSeleccionada.id) ? (
                                <>
                                    {/* Botón para Agregar un nueva promocion en matriz de promociones */}
                                    <div className="flex-row justify-content-start mb-3">
                                        <Button
                                            variant="success"
                                            onClick={() => {
                                                if (!seccionSeleccionada) {
                                                    Swal.fire({icon: "error", title: "Error", text: "Debe seleccionar una sección válida antes de agregar una promoción."});
                                                    return;
                                                    // alert("Debe seleccionar una sección válida antes de agregar una promoción.");
                                                    // return;
                                                }
                                                setPromocionSeleccionada(null);
                                                setModalShowPromociones(true);
                                            }}
                                        >
                                            Agregar nueva promoción
                                        </Button>
                                    </div>


                                    {/* Aquí se muestra el grid de promociones similar a GestorArchivos, pero sin el formulario de subida */}
                                    {promociones.length === 0 ? (
                                        <p>No hay promociones.</p>
                                    ) : (
                                        <div className="gestor-file-grid">
                                            {promociones.map((promocion) => (
                                                <div key={promocion.id} className="gestor-file-card">
                                                    {/* Se muestra la imagen; asegúrate de que la propiedad (ruta_archivo o ruta_imagen) corresponda */}
                                                    {promocion.ruta_archivo ? (
                                                        promocion.ruta_archivo.toLowerCase().endsWith(".pdf") ? (
                                                            <iframe
                                                                src={promocion.ruta_archivo} // URL del PDF
                                                                title="PDF"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "400px",
                                                                    borderRadius: "8px",
                                                                    border: "none",
                                                                }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={promocion.ruta_archivo} // Mostrar imagen normal
                                                                alt="Vista previa"
                                                                className="file-preview"
                                                            />
                                                        )
                                                    ) : (
                                                        <div className="file-icon"> 📑 </div> // Emoji de archivo si no hay imagen ni PDF
                                                    )}


                                                    <h3 className="file-title text-break">{promocion.nombre_oferta}</h3>
                                                    {/* Puedes agregar información adicional, por ejemplo, fecha o estado */}
                                                    <div className="d-flex flex-column">
                                                        <button className="gestor-download-button"
                                                            variant="primary"
                                                            onClick={() => {
                                                                setPromocionSeleccionada(promocion);
                                                                setModalShowPromociones(true);
                                                            }}
                                                        >
                                                            ✏️ Editar
                                                        </button>
                                                        <button
                                                            className="gestor-delete-button"
                                                            onClick={() => handleEliminarPromocion(promocion.id)}
                                                        >
                                                            🗑 Eliminar
                                                        </button>
                                                        <button className="gestor-archivar-button">📁
                                                            Archivar
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <GestorArchivos
                                    seccionId={seccionSeleccionada.id}
                                    acceptedFileTypes={seccionSeleccionada.acceptedFileTypes}
                                />
                            )

                        }

                    </>
                ) : (
                    <BannerBienvenidaResponsivo/>
                )}

                {/* Modal del formulario para Alta/Edición de Puntos de Venta */}
                <Modal show={modalShow} onHide={() => setModalShow(false)} style={{paddingTop: "80px"}}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {puntoVentaSeleccionado ? "Editar Punto de Venta" : "Agregar Punto de Venta"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormularioPuntoVenta
                            puntoVentaSeleccionado={puntoVentaSeleccionado}
                            onGuardar={() => {
                                setModalShow(false);
                                refrescarPuntosVenta();
                            }}
                            onCancelar={() => setModalShow(false)}
                        />
                    </Modal.Body>
                </Modal>

                {/* Modal del formulario para Alta/Edición de Promociones */}
                <Modal
                    show={modalShowPromociones}
                    onHide={() => setModalShowPromociones(false)}
                    centered
                    backdrop="static" // Evita que se cierre accidentalmente
                    keyboard={false} // Evita que el usuario cierre con teclado
                    style={{ paddingTop: "80px" }}
                >

                    <Modal.Header closeButton>
                        <Modal.Title>
                            {promocionSeleccionada ? "Editar Promoción" : "Agregar Promoción"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {modalShowPromociones && seccionSeleccionada ? (
                            <FormularioPromociones
                                show={modalShowPromociones}
                                onGuardar={() => {
                                    setModalShowPromociones(false);
                                    refrescarMatrizPromociones();
                                }}
                                onHide={() => setModalShowPromociones(false)}
                                promocionSeleccionada={promocionSeleccionada} // <-- Cambiado aquí
                                seccionId={seccionSeleccionada.id} // Se pasa el ID de la sección
                                onCancelar={() => setModalShowPromociones(false)}
                            />
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </Modal.Body>


                </Modal>

            </div>
        </div>
    );
};

export default GestorAdmin;